module.exports = __webpack_public_path__ + "static/media/Hecuba.38b9ab6c.jpg";